














import { Vue, Component, Prop } from "@/shared/vuepack";
import VS2 from "vue-script2";
import { loggingEnabled, getClientToken } from "@/shared/datadog";

Vue.use(VS2);

@Component
export default class DatadogScript extends Vue {
  get shouldLog () {
    return loggingEnabled();
  }
  get token () {
    return getClientToken();
  }
}
